import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ModalContext = /*#__PURE__*/createContext({});
export var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    modals = _useState2[0],
    setModals = _useState2[1];
  var closeModal = function closeModal() {
    return setModals([]);
  };
  var openModal = function openModal(name) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return setModals(function (old) {
      return [].concat(_toConsumableArray(old), [_objectSpread(_objectSpread({}, props), {}, {
        name: name
      })]);
    });
  };
  var previousModal = function previousModal() {
    return setModals(function (old) {
      return old.slice(0, old.length - 1);
    });
  };
  return /*#__PURE__*/_jsx(ModalContext.Provider, {
    value: {
      closeModal: closeModal,
      modals: modals,
      openModal: openModal,
      previousModal: previousModal
    },
    children: children
  });
};
export var useModal = function useModal() {
  return useContext(ModalContext);
};